<div v-if="inline">
  <div class="card-body">
    <div
      v-for="(sponsor, index) in sponsors"
      :key="String(sponsor?.id ?? index)"
      class="border rounded-5 p-2 mb-3 bg-light position-relative"
    >
      <button class="btn btn-sm btn-danger position-absolute top-0 end-0 m-3 rounded-circle"
              type="button"
              @click="remove_sponsor(index)">
        &times;
      </button>

      <p class="text-primary fw-bold small">SPONSOR {{ index + 1 }}</p>
      <div class="row">
        <div class="col-md-3 text-center">
          <div class="border border-danger border-2 rounded-circle d-flex align-items-center justify-content-center mx-auto profile-preview-img pointer"
              @click="$refs['logo'+index][0].click()">
            <img v-if="sponsor.logoPreviewUrl"
                :src="sponsor.logoPreviewUrl"
                class="w-100 h-100 object-fit-cover" />
            <i v-else class="bx bx-image fs-1 text-secondary"></i>
          </div>

          <input type="file"
                class="d-none"
                :ref="'logo'+index"
                accept="image/*"
                @change="handle_logo_upload($event, index)" />

          <small class="text-danger d-block mt-2 text-xxs cursor-pointer"
                @click="$refs['logo'+index][0].click()">
            {{ sponsor.logoPreviewUrl ? 'Change logo' : 'Upload logo' }}
          </small>
        </div>

        <div class="col-md-9">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label text-xxs fw-500">Sponsor Name</label><span class="text-danger">*</span>
              <input type="text"
                      v-model="sponsor.name"
                      class="form-control rounded text-xxs"
                      placeholder="e.g. Acme Corp">
              <p v-if="sponsors_errors['sponsor_name' + index]" class="text-danger text-xxs">
                {{ sponsors_errors['sponsor_name' + index] }}
              </p>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label text-xxs fw-500">Website URL</label>
              <input type="url"
                      v-model="sponsor.website_url"
                      class="form-control rounded text-xxs"
                      placeholder="https://example.com">
              <p v-if="sponsors_errors['sponsor_url' + index]" class="text-danger text-xxs">
                {{ sponsors_errors['sponsor_url' + index] }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button class="btn btn-sm btn-primary rounded text-xxs cursor-pointer"
            type="button"
            @click="add_sponsor_button">
      Add Sponsor
    </button>

    <div class="d-flex justify-content-end mt-3">
      <button class="btn btn-primary btn-sm text-xxs me-2"
              type="button"
              @click="save_sponsors">
        Save
      </button>
    </div>
  </div>
</div>

<!-- Add Sponsors Modal -->
<teleport to="body">
  <div class="modal fade" id="add_sponsors_modal" tabindex="-1" aria-labelledby="addSponsorsModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content rounded shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-white text-xxs" id="addSponsorsModalLabel">Add Sponsors</h5>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body table-responsive">
          <div class="modal-body">
            <div
              v-for="(sponsor, index) in sponsors"
              :key="index"
              class="border rounded-5 p-2 mb-3 bg-light position-relative"
            >
              <button class="btn btn-sm btn-outline-danger position-absolute top-0 end-0 m-3 rounded-circle"
                      @click="remove_sponsor(index)">
                x
              </button>

              <p class="text-primary fw-bold small">SPONSOR {{ index + 1 }}</p>
              <div class="row">
                <div class="col-md-3 text-center">
                  <div class="border border-danger border-2 rounded-circle d-flex align-items-center justify-content-center mx-auto profile-preview-img pointer"
                      @click="$refs['logo'+index][0].click()">
                    <img v-if="sponsor.logoPreviewUrl"
                        :src="sponsor.logoPreviewUrl"
                        class="w-100 h-100 object-fit-cover" />
                    <i v-else class="bx bx-image fs-1 text-secondary"></i>
                  </div>

                  <input type="file"
                        class="d-none"
                        :ref="'logo'+index"
                        accept="image/*"
                        @change="handle_logo_upload($event, index)" />

                  <small class="text-danger d-block mt-2 text-xxs cursor-pointer"
                        @click="$refs['logo'+index][0].click()">
                    {{ sponsor.logoPreviewUrl ? 'Change logo' : 'Upload logo' }}
                  </small>
                </div>

                <div class="col-md-9">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label class="form-label text-xxs fw-500">Sponsor Name</label><span class="text-danger">*</span>
                      <input type="text"
                             v-model="sponsor.name"
                             class="form-control rounded text-xxs"
                             placeholder="e.g. Acme Corp">
                      <p v-if="sponsors_errors['sponsor_name' + index]" class="text-danger text-xxs">
                        {{ sponsors_errors['sponsor_name' + index] }}
                      </p>
                    </div>

                    <div class="col-md-6 mb-3">
                      <label class="form-label text-xxs fw-500">Website URL</label>
                      <input type="url"
                             v-model="sponsor.website_url"
                             class="form-control rounded text-xxs"
                             placeholder="https://example.com">
                      <p v-if="sponsors_errors['sponsor_url' + index]" class="text-danger text-xxs">
                        {{ sponsors_errors['sponsor_url' + index] }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button class="btn btn-outline-danger w-100 rounded-5 text-xxs py-2"
                    @click="add_sponsor_button">
              Add Sponsor
            </button>
          </div>

          <div class="modal-footer border-0">
            <button class="btn btn-primary btn-sm text-xxs me-2"
                    @click="save_sponsors">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<!-- View Sponsors Modal -->
<teleport to="body">
  <div class="modal fade" id="event_sponsors_modal" tabindex="-1" aria-labelledby="eventSponsorsModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-white text-xxs" id="eventSponsorsModalLabel">Event Sponsors</h5>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body bg-light px-4 pb-4">
          <div v-if="selected_event?.sponsors?.length > 0" class="row g-3">
            <div
              class="col-12 col-sm-6 col-md-4"
              v-for="sponsor in selected_event?.sponsors"
              :key="sponsor.id"
            >
              <div class="card h-100 text-center border-0 shadow-sm position-relative rounded-4 transition-all">
                <div class="position-absolute top-0 end-0 p-2 d-flex gap-1">
                  <button
                    v-if="can_edit"
                    class="btn btn-sm btn-light border-0 text-primary rounded-circle action-btn shadow-none"
                    @click="edit_sponsor(sponsor)"
                    title="Edit"
                  >
                    <i class='bx bx-edit'></i>
                  </button>
                  <button
                    v-if="can_edit"
                    class="btn btn-sm btn-light border-0 text-danger rounded-circle action-btn shadow-none"
                    @click="delete_sponsor(sponsor.id)"
                    title="Delete"
                  >
                    <i class='bx bx-trash'></i>
                  </button>
                </div>
                <div class="card-body d-flex flex-column align-items-center p-4">
                  <div class="circular-progress-container rounded-circle d-flex align-items-center justify-content-center mb-3">
                    <img
                      v-if="get_sponsor_logo(sponsor)"
                      :src="get_sponsor_logo(sponsor)"
                      class="rounded-circle w-100 h-100 object-fit-cover"
                    >
                    <div v-else class="text-dark-purple fs-2">
                      <i class="bx bxs-building"></i>
                    </div>
                  </div>
                  <h6 class="fw-bold text-dark mb-1 fs-6">{{ sponsor?.name }}</h6>
                  <a
                    v-if="sponsor?.website_url"
                    :href="format_sponsor_url(sponsor?.website_url)"
                    target="_blank"
                    class="text-decoration-none text-xxs text-secondary"
                  >
                    Visit website <i class="bi bi-box-arrow-up-right ms-1"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-center text-muted text-xxs">
            No sponsors added yet.
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<!-- Edit Sponsor Modal -->
<teleport to="body">
  <div class="modal fade" id="edit_sponsor_modal" tabindex="-1" aria-labelledby="editSponsorModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content rounded shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-white text-xxs" id="editSponsorModalLabel">Edit Sponsor</h5>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body table-responsive" v-if="selected_sponsor">
          <div class="modal-body">
            <div class="border rounded-5 p-3 mb-3 bg-light position-relative">
              <div class="row">
                <div class="col-md-3 text-center">
                  <div class="border border-danger border-2 rounded-circle d-flex align-items-center justify-content-center mx-auto profile-preview-img pointer"
                      @click="$refs.editLogoInput.click()">
                    <img
                      v-if="editLogoPreviewUrl || get_sponsor_logo(selected_sponsor)"
                      :src="editLogoPreviewUrl || get_sponsor_logo(selected_sponsor)"
                      class="w-100 h-100 object-fit-cover"
                    />
                    <i v-else class="bx bx-image fs-1 text-secondary"></i>
                  </div>

                  <input type="file"
                        class="d-none"
                        ref="editLogoInput"
                        accept="image/*"
                        @change="handle_edit_logo_upload($event)" />

                  <small class="text-danger d-block mt-2 text-xxs pointer"
                        @click="$refs.editLogoInput.click()">
                    {{ editLogoPreviewUrl || get_sponsor_logo(selected_sponsor) ? 'Change logo' : 'Upload logo' }}
                  </small>
                </div>

                <div class="col-md-9">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label class="form-label text-xxs fw-500">Sponsor Name</label><span class="text-danger">*</span>
                      <input type="text" v-model="selected_sponsor.name" class="form-control rounded text-xxs">
                      <p v-if="edit_errors.name" class="text-danger text-xxs">{{ edit_errors.name }}</p>
                    </div>

                    <div class="col-md-6 mb-3">
                      <label class="form-label text-xxs fw-500">Website URL</label>
                      <input type="url" v-model="selected_sponsor.website_url" class="form-control rounded text-xxs">
                      <p v-if="edit_errors.website_url" class="text-danger text-xxs">{{ edit_errors.website_url }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer border-0">
            <button class="btn btn-primary btn-sm text-xxs" @click="update_sponsor">Update Details</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
